import type { IconData } from '@stacksjs/iconify-core'

export const interfaceEssentialPencilEdit1: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M21.33 24.38v1.52h1.52v-1.52h1.53V3.05h-1.53V6.1H9.14V3.05H7.62v21.33h1.52v1.52h1.52v-1.52ZM19.81 7.62h3.04v15.24h-3.04Zm-6.1 0h4.57v15.24h-4.57ZM9.14 22.86V7.62h3.05v15.24ZM21.33 1.52h1.52v1.53h-1.52ZM19.81 25.9h1.52v1.53h-1.52ZM16.76 32v-1.52h1.52v-1.53h1.53v-1.52h-7.62v1.52h1.52v1.53h1.53V32zm-6.1-32h10.67v1.52H10.66Zm0 25.9h1.53v1.53h-1.53ZM9.14 1.52h1.52v1.53H9.14Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default interfaceEssentialPencilEdit1
